export default "__VITE_ASSET__1ca4e9b8__"